export const parseProviderOptionDraft = (draft: Record<string, string>): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(draft).map(([option, value]) => {
      try {
        return [option, JSON.parse(value)];
      } catch {
        throw new Error(`Invalid JSON value for ${option}`);
      }
    }),
  );
